export default "__VITE_ASSET__BgTcq_EY__"